export const SUBSCRIPTION_STATUS = {
  FREE: 1,
  ACTIVE: 3,
  SUSPENDED: 4,
  CANCELLED: 5
}

export const SUBSCRIPTION_LICENSE_TYPE = {
  ESSENTIAL: 'Essential',
  PROFESSIONAL: 'Professional'
}

export const SUBSCRIPTION_PLATFORM = {
  MICROSOFT: 'Microsoft',
  STRIPE: 'Stripe',
  STRIPE_SEND_INVOICE: 'Stripe - Send invoice',
  BANK_TRANSFER: 'Bank transfer'
}

export const TEAMFLECT_TENANT_ID = '888a859c-c680-4344-ab07-24bd768bf73a'

export const INTERNAL_BETA_TENANT_IDS = [
  TEAMFLECT_TENANT_ID,
  '086d2f1b-5b64-4dbf-9244-d1511acdea88', // MullanyCorp
  '4c7e40b7-8ab4-4c43-84c2-a7f66ebcf91d', // Denzel Coffee Roasters
  'd1d64445-aa8a-4c21-b9ff-c858bcc572fe', // PembrokeCorp
  'c60ce936-fc72-4194-927b-082018956c4d', // Langen Corp
  '1e1f234a-1434-4ee7-83e5-6b90d6c600a0', // Teamblee
  'd51e748d-f539-4a46-93b9-d7c4a7336796', // Dogan Test Tenant
  '655d9964-0506-41d0-8b05-e01b63ea933f', // Kedioglu Holding
  'd7bcb493-c9a8-45b4-a6f7-3967824de336', // Jay Sharris Corp
  '92a3d738-143f-4fce-bd3b-76b605664b31' // Reserved for Sales Team
]
